import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const ChartContainer = styled(Box)<{ size: number }>`
  position: relative;
  width: ${({ size }) => size}px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`

export const ValueWrapper = styled(Box)`
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;

  .value {
    color: ${theme.colors.legacyNeutral2};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.bold};
    font-size: 48px;
    font-style: normal;
    line-height: 60px;
    margin-bottom: 12px;

    html[data-theme='light'] & {
      color: ${theme.colors.foreground};
    }
  }

  .indicators-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
  }

  .change-indicator {
    display: flex;
    align-items: flex-end;
    gap: 6px;

    .change-value {
      display: flex;
      align-items: center;
      gap: 4px;

      .arrow-icon {
        display: block;
        flex-shrink: 0;
        width: 14px;
        height: 14px;
        stroke-width: 2;
      }

      .change-text {
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.bold};
        font-size: ${theme.typography.fontSize.large};
        line-height: 20px;
      }

      &.positive {
        color: ${theme.colors.statusValueGood};
        .change-text {
          color: ${theme.colors.statusValueGood};
        }
      }

      &.negative {
        color: #e74c3c;
        .arrow-icon {
          transform: rotate(180deg);
        }
        .change-text {
          color: #e74c3c;
        }

        html[data-theme='light'] & {
          color: ${theme.colors.statusValueBad};
          .change-text {
            color: ${theme.colors.statusValueBad};
          }
        }
      }
    }

    .since-label {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.normal};
      font-size: ${theme.typography.fontSize.large};
      color: ${theme.colors.softMauve};
      line-height: 20px;
      letter-spacing: 0.25px;

      html[data-theme='light'] & {
        color: #5c5865;
      }
    }
  }
`

export const OverPerformanceIndicator = styled(Box)`
  display: flex;
  align-items: flex-end;
  gap: 6px;
  margin-top: 4px;

  .icon-text {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .over-value {
    color: ${theme.colors.overPerformanceIndicator};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
  }

  .over-text {
    color: ${theme.colors.softMauve};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 20px;

    html[data-theme='light'] & {
      color: #5c5865;
    }
    letter-spacing: 0.25px;
  }
`
